import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getNonManageablePrependedGallectionsCount, getCurrentFolderId, } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
function moveGallectionToPosition(action) {
    var _a, folderId, position, moveType, mediaSource, currentFolderId, nonManageablePrependedGallectionsCount, streamId, params;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, folderId = _a.folderId, position = _a.position, moveType = _a.moveType;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _c.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _c.sent();
                return [4 /*yield*/, select(getNonManageablePrependedGallectionsCount)];
            case 3:
                nonManageablePrependedGallectionsCount = _c.sent();
                streamId = getGallectionStreamId(mediaSource, currentFolderId);
                if (!(!moveType || moveType === 'streamOnly')) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.moveItem({ streamId: streamId, item: folderId, position: position }))];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5:
                if (!(!moveType || moveType === 'papiOnly')) return [3 /*break*/, 7];
                params = {
                    folderid: folderId,
                    type: (_b = getGallectionType(mediaSource)) !== null && _b !== void 0 ? _b : 'collection',
                    position: position - nonManageablePrependedGallectionsCount, // because All, Featured folders are prepended immovable objects that do not reserve a spot on the BE
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update_order',
                        data: params,
                    })];
            case 6:
                _c.sent();
                _c.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export default moveGallectionToPosition;
//# sourceMappingURL=moveGallectionToPosition.js.map